import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeardIslandAndMcdonaldIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1683_3537)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V20H0V0Z",
				fill: "#00008B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 0V1.25L6.28906 5L10 8.65234V10H8.69141L4.96094 6.32812L1.32812 10H0V8.67188L3.63281 5.01953L0 1.44531V0H1.21094L4.96094 3.67188L8.59375 0H10Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.59375 6.32812L3.80859 6.99219L0.820312 10H0V9.94141L3.59375 6.32812ZM6.01562 6.09375L7.07031 6.25L10 9.12109V10L6.01562 6.09375ZM10 0L6.25 3.82812L6.17188 2.96875L9.10156 0H10ZM0 0.0195312L3.76953 3.71094L2.61719 3.55469L0 0.957031V0.0195312Z",
				fill: "#FF0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.4375 0V10H6.5625V0H3.4375ZM0 3.4375V6.5625H10V3.4375H0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4.0625V5.9375H10V4.0625H0ZM4.0625 0V10H5.9375V0H4.0625Z",
				fill: "#FF0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.89062 15.7344L6.10156 15.9453L6.28125 17.7383L5 16.4727L3.71094 17.7305L3.90234 15.9375L2.11328 15.7109L3.63281 14.7422L2.69531 13.2031L4.39844 13.7891L5.01562 12.0938L5.62109 13.793L7.32812 13.2188L6.37891 14.75L7.89453 15.7305L7.89062 15.7344ZM16.5898 16.0469L15.7891 16.1484L15.875 16.9492L15.2969 16.3867L14.7227 16.9531L14.8008 16.1523L14 16.0586L14.6758 15.6211L14.25 14.9375L15.0156 15.1914L15.2852 14.4297L15.5625 15.1875L16.3242 14.9258L15.9062 15.6133L16.5898 16.0469ZM16.2109 11.4688L16.3164 10.9609L15.9336 10.6094L16.4492 10.5508L16.6641 10.0781L16.8789 10.5508L17.3945 10.6094L17.0117 10.9609L17.1172 11.4688L16.6641 11.2109L16.2109 11.4688ZM12.9258 9.125L12.1328 9.21094L12.2031 10.0039L11.6406 9.4375L11.0625 9.98828L11.1562 9.19531L10.3672 9.08984L11.043 8.66797L10.6328 7.98438L11.3867 8.25L11.668 7.50391L11.9297 8.25781L12.6875 8.01172L12.2617 8.6875L12.9258 9.125ZM19.793 7.84375L18.9766 7.94922L19.0664 8.76562L18.4766 8.19141L17.8906 8.76953L17.9727 7.94922L17.1562 7.85547L17.8477 7.40625L17.4141 6.70703L18.1953 6.96875L18.4688 6.19531L18.75 6.96875L19.5273 6.69922L19.0977 7.40234L19.793 7.84375ZM16.5859 4.58203L15.7773 4.67188L15.8516 5.48437L15.2773 4.90625L14.6875 5.46875L14.7812 4.66016L13.9727 4.55078L14.6641 4.12109L14.2461 3.42187L15.0156 3.69141L15.3008 2.92969L15.5664 3.69922L16.3398 3.44531L15.9062 4.13281L16.5859 4.58203Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1683_3537",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgHeardIslandAndMcdonaldIslands;
